// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ExamsCovered_wrapper__lyakz","exam":"ExamsCovered_exam__YKYfz","examTitle":"ExamsCovered_examTitle__RnQuk","skeleton-loading":"ExamsCovered_skeleton-loading__7ZaUh"};